import mitt from "mitt";

const instance = mitt();

export default instance;
